import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import axios from "axios";

function PointReport(props) {
  const [loading, setLoading] = useState(false);
  const [pointDetails, setPointDetails] = useState({});
  const [pointKeys, setPointKeys] = useState([]);

  const [zone, setZone] = useState(-1);

  useEffect(() => {
    if (localStorage.getItem("userdata")) {
      var userdata = JSON.parse(localStorage.getItem("userdata"));
      if (["ADMIN", "OFFICE"].includes(userdata.role)) {
        setZone(0);
      }
      if (["HOD", "CR", "ZI"].includes(userdata.role)) {
        setZone(0);
      }
      if ("ZONE_OFFICE" === userdata.role) {
        setZone(userdata.zoneId);
      }
    }
  }, []);

  useEffect(() => {
    if (
      props.zone !== undefined &&
      props.zone !== null &&
      props.zone !== "" &&
      props.zone !== zone
    ) {
      setZone(props.zone);
    }
  }, [props, zone]);

  useEffect(() => {
    // Wait until the zone is resolved so we never POST an empty/invalid payload.
    if (zone === -1 || zone === undefined || zone === null) {
      return;
    }
    setLoading(true);
    axios
      .post(
        "https://a9s48sduha.execute-api.ap-northeast-1.amazonaws.com/v1/weekly/reports/pointreport",
        { zoneId: zone },
        { headers: { "Content-Type": "application/json" } }
      )
      .then(function (response) {
        const data = response.data || {};
        const status = data.status;

        // Parse the points payload from whichever shape the API returns.
        let points = null;
        if (typeof data.body === "string") {
          try {
            points = JSON.parse(data.body);
          } catch (e) {
            points = null;
          }
        } else if (data.body && typeof data.body === "object") {
          points = data.body;
        } else if (!status && typeof data === "object") {
          // Proxy-style response: the body itself is the points object.
          points = data;
        }

        if (status === "Failure" || status === "FAILURE") {
          const message =
            (points && (points.message || points.error)) ||
            "Unable to load the point report. Please try again.";
          alert(message);
          setPointDetails({});
        } else if (points && typeof points === "object") {
          setPointDetails(points);
        } else {
          setPointDetails({});
        }
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  }, [zone]);
  useEffect(() => {
    if (pointDetails && Object.keys(pointDetails).length > 0) {
      setPointKeys(Object.keys(pointDetails));
    }
  }, [pointDetails]);

  return (
    <>
      {loading ? (
        <div className="flex justify-center py-12">
          <img src="/images/loading.gif" alt="loading" className="w-12 h-12" />
        </div>
      ) : (
        <div className="grid grid-cols-12 gap-5 printable w-full">
          <div className="page-title">Point Report</div>
          <div className="text-lg uppercase col-span-12">
            {/* Time in HH:MM */}
            Date: {new Date().toLocaleDateString()} &nbsp; Time:{" "}
            {new Date().toLocaleTimeString()}
          </div>
          <div className="col-span-12">
            {pointKeys.length > 0 &&
              pointKeys.map((key) => {
                return (
                  <>
                    <div className="col-span-12 my-10">
                      <div className="text-3xl uppercase">{key}</div>
                    </div>
                    <div className="col-span-12">
                      <div className="grid grid-cols-12 gap-5">
                        {pointDetails &&
                          Object.keys(pointDetails[key]).length > 0 &&
                          pointDetails[key].map((point) => {
                            return (
                              <>
                                <PointCard point={point} />
                              </>
                            );
                          })}
                      </div>
                    </div>
                  </>
                );
              })}
          </div>
        </div>
      )}
    </>
  );
}

function PointCard(props) {
  //   {
  //     "sewadarBadge": row["sewadarBadge"],
  //     "sewadarName": row["sewadarName"],
  //     "sewadarReportingTime": row["sewadarReportingTime"],
  //     "pointName": row["pointName"],
  //     "jacketNo": row["jacketNo"]

  // }

  return (
    <>
      <div className="col-span-12 md:col-span-4 lg:col-span-3 flex-wrap">
        <div
          className={
            "shadow-md rounded-lg p-4 " +
            (props.point.sewadarBadge !== null
              ? "bg-green-700 text-white"
              : "bg-gray-300")
          }
        >
          <div className="grid grid-cols-12 gap-5">
            <div className="col-span-12">
              <div className="lg:text-lg uppercase font-bold">
                {props.point.pointName}
              </div>
            </div>
            <div className="col-span-12">
              <div className="text-lg uppercase">
                {props.point.sewadarBadge}
              </div>
              <div className="col-span-12">
                <div className="text-lg uppercase">
                  {props.point.sewadarName}
                </div>
              </div>
              <div className="col-span-12">
                <div className="text-lg uppercase">
                  {props.point.sewadarPhone !== null
                    ? "phone: " + props.point.sewadarPhone
                    : ""}
                </div>
              </div>

              <div className="col-span-12">
                <div className="text-lg uppercase">
                  {props.point.sewadarReportingTime}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PointReport;
